// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { UsersList } from "@/features/iam/users-list";

interface GroupUsersTabProps {
  groupName: string;
  // Accepted for parity with the other tabs; the embedded users list manages its own state.
  initialFilters?: string;
}

// The group's members are the full Users list scoped to this group — same columns, filters,
// actions and Create User button (which prefills this group). Shown active-only to match the
// group's user count.
export function GroupUsersTab({ groupName }: GroupUsersTabProps) {
  return <UsersList group={groupName} />;
}
